import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-ip-confirm-action-dialog',
  templateUrl: './ip-confirm-action-dialog.component.html',
  styleUrls: ['./ip-confirm-action-dialog.component.scss']
})
export class IpConfirmActionDialogComponent {
  page!: string | undefined;
  title!: string; 
  content?: string
  btnAction = false;

  constructor(
    public dialogRef: MatDialogRef<IpConfirmActionDialogComponent>,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if(data.page) this.page = data.page;
      else this.page = undefined;
    if (data.content) this.content = data.content
    if (data.btnAction) this.btnAction = data.btnAction;
    this.title = this.translateService.instant(this.data.question + (this.page == undefined ? this.data.id + '?' : ''))
   }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
